import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl }) => {
  return (
    <Col xs={12} sm={6} md={4}>
      <div className="proj-card">
        <div className="proj-img-wrap">
          <img src={imgUrl} alt="project" />
          <div className="proj-overlay">
            <div className="proj-overlay-content">
              <span className="proj-tag">{description}</span>
              <h4>{title}</h4>
            </div>
          </div>
        </div>
        <div className="proj-footer">
          <span>{title}</span>
        </div>
      </div>
    </Col>
  );
};
